import { toBase64 } from '@change-corgi/core/base64';

/**
 * Encodes a string as base64url (RFC 4648 §5).
 *
 * Produces standard base64 and then swaps `+`/`/` for `-`/`_` and drops
 * `=` padding, so the result is safe to use unescaped in URLs and
 * filenames.
 *
 * @param input - The string to encode.
 * @returns The base64url-encoded string.
 */
export function toBase64Url(input: string): string {
	return toBase64(input).replace(/[+/=]/g, (match) => {
		switch (match) {
			case '+':
				return '-'; // Convert '+' to '-'
			case '/':
				return '_'; // Convert '/' to '_'
			case '=':
				return ''; // Remove ending '='
			default:
				return match;
		}
	});
}
